import { Component, inject } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import {BlogRoute, CollaboratorRoute, DocumentsRoute, FaqRoute, ProductLandingRoute} from 'src/models/routes.model';

interface FooterLink {
  name: string;
  route?: string;
  fragment?: string;
  link?: string | SafeResourceUrl;
  items?: FooterLink[]
}

@Component({
  selector: 'liberro-basic-layout-footer-links',
  standalone: false,
  templateUrl: './basic-layout-footer-links.component.html',
  styleUrl: './basic-layout-footer-links.component.less'
})
export class BasicLayoutFooterLinksComponent {
  private sanitizer = inject(DomSanitizer);

  public footerLinkGroups: FooterLink[];

  public constructor() {
    this.footerLinkGroups = [
      {
        name: 'footer.links.products.title',
        route: '',
        items: [
          { name: 'footer.links.products.items.thematicStrategy', route: `/${ProductLandingRoute.PRODUCT}/${ProductLandingRoute.THEMATIC_STRATEGY}` },
          { name: 'footer.links.products.items.customStrategy', route: `/${ProductLandingRoute.PRODUCT}/${ProductLandingRoute.CUSTOM_STRATEGY}` },
        ]
      },
      {
        name: 'footer.links.informationAndSupport.title',
        route: '',
        items: [
          { name: 'footer.links.informationAndSupport.items.myConsultant', route: `/${CollaboratorRoute.COLLABORATOR}` },
          { name: 'footer.links.informationAndSupport.items.needAdvice', route: `/${FaqRoute.FAQ}` },
          { name: 'footer.links.informationAndSupport.items.posts', route: `/${BlogRoute.BLOG}` },
          { name: 'footer.links.informationAndSupport.items.documents', route: `/${DocumentsRoute.DOCUMENTS}` }
        ]
      },
      {
        name: 'footer.links.conditions.title',
        route: '',
        items: [
          { name: 'footer.links.conditions.items.personalDataProtection', link: this.sanitizer.bypassSecurityTrustResourceUrl('https://docs.bcas.cz/BWM/Informace_o_zpracov%C3%A1n%C3%AD_osob_%C3%BAdaj%C5%AF_klient%C5%AF_BWM.pdf') },
          { name: 'footer.links.conditions.items.informationForCustomers', link: this.sanitizer.bypassSecurityTrustResourceUrl('https://docs.bcas.cz/BWM/Informace_a_sd%C4%9Blen%C3%AD_pro_z%C3%A1kazn%C3%ADky_BWM.pdf') },
        ]
      }
    ];
  }

}
